export const dbKeyPath = 'id';
export type DbKeyType = 'notifications';

export const openIDB = (dbKey: DbKeyType): Promise<IDBDatabase> => {
  return new Promise((resolve, reject) => {
    const dbRequest = indexedDB.open(dbKey);

    dbRequest.onupgradeneeded = () => {
      const db = dbRequest.result;
      if (!db.objectStoreNames.contains(dbKey)) {
        db.createObjectStore(dbKey, { keyPath: dbKeyPath });
      }
    };

    dbRequest.onsuccess = () => {
      resolve(dbRequest.result);
    };

    dbRequest.onerror = (event) => {
      console.error('Database error:', event);
      reject(event);
    };
  });
};

export const addIDB = async (dbKey: DbKeyType, id: string, data: Record<string, unknown>) => {
  if (!id) {
    console.error('ID is required to add an object to IndexedDB');
    return;
  }

  try {
    const db = await openIDB(dbKey);
    const transaction = db.transaction([dbKey], 'readwrite');
    const objectStore = transaction.objectStore(dbKey);
    const req = objectStore.put({ id, ...data });

    req.onerror = (event) => {
      console.error('Failed to put object:', event);
    };
  } catch (error) {
    console.error('Error in handleAdd:', error);
  }
};

export const removeByIdIDB = async (dbKey: DbKeyType, id: string) => {
  try {
    const db = await openIDB(dbKey);
    const transaction = db.transaction([dbKey], 'readwrite');
    const objectStore = transaction.objectStore(dbKey);
    const req = objectStore.delete(id);

    req.onerror = (event) => {
      console.error('Failed to delete object:', event);
    };
  } catch (error) {
    console.error('Error in handleRemove:', error);
  }
};

export const getByIdIDB = async (dbKey: DbKeyType, id: string) => {
  try {
    const db = await openIDB(dbKey);
    const transaction = db.transaction([dbKey], 'readonly');
    const objectStore = transaction.objectStore(dbKey);
    const req = objectStore.get(id);

    return new Promise((resolve, reject) => {
      req.onsuccess = () => {
        resolve(req.result);
      };

      req.onerror = (event) => {
        console.error('Failed to get object:', event);
        reject(event);
      };
    });
  } catch (error) {
    console.error('Error in getById:', error);
  }
};

export const getAllIDB = async (dbKey: DbKeyType): Promise<unknown[]> => {
  try {
    const db = await openIDB(dbKey);
    const transaction = db.transaction([dbKey], 'readonly');
    const objectStore = transaction.objectStore(dbKey);
    const req = objectStore.getAll();

    return new Promise((resolve, reject) => {
      req.onsuccess = () => {
        resolve(req.result);
      };

      req.onerror = (event) => {
        console.error('Failed to get all objects:', event);
        reject(event);
      };
    });
  } catch (error) {
    console.error('Error in getAll:', error);
    return [];
  }
};
